export { SearchTrigger } from '@/components/molecules/search/SearchTrigger';
